import type { ResourceKey } from 'i18next';
import { createI18n, resolveLocale, type Locale } from '@link/share/i18n';

export type { Locale };
export { resolveLocale };

// Triplabo defaults to English because the Shinkansen booking flow has no
// Japanese translations, matching the SPA's `src/i18n/index.ts`.
export const DEFAULT_LOCALE: Locale = 'en';

// Shinkansen is not available in Japanese.
export const SHINKANSEN_LOCALES: readonly Locale[] = ['en', 'ko', 'zh', 'zt'];

/**
 * An i18n instance for `locale`, from the translations the root loader
 * returned (see `getTranslations`, which already fills in English).
 *
 * Created during render, never shared at module scope: on the server each
 * request gets its own, so concurrent requests in different languages cannot
 * race on one instance's active language.
 */
export const createAppI18n = (locale: Locale, translations: ResourceKey) =>
  createI18n({
    locale,
    resources: { [locale]: { translation: translations } }
  });

/** Narrow a route param to a supported locale, defaulting to English. */
export const resolveAppLocale = (value: unknown): Locale =>
  resolveLocale(value, DEFAULT_LOCALE);
